import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CustomerDecisionPage.DecisionMadeSection', {
    acceptedStatusText: 'Accepted',
    rejectedStatusText: 'Declined',
    commentSectionTitle: 'Comment',
    notificationText: 'The customer decision was already made in ApprovalMax',
});
